import classNames from 'classnames';
import React from 'react';
import { useTooltip } from '../context';
import styles from './styles.module.scss';

const ReactTooltip = ({
  className,
  children,
  content,
  position,
  color = '#23176B'
}) => {
  const ref = React.useRef(null);
  const {
    hide,
    show
  } = useTooltip();

  const handleMouseIn = () => {
    var _ref$current;

    const rect = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect();
    rect && show({
      title: content,
      position: {
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        height: rect.height
      },
      direction: position,
      color
    });
  };

  const handleMouseOut = () => {
    hide();
  };

  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classNames(styles.container, className),
    onMouseOver: handleMouseIn,
    onMouseLeave: handleMouseOut
  }, children);
};

export default ReactTooltip;